export default __webpack_public_path__ + "static/media/gal-2.d7d05a69.jpg";